document.addEventListener('DOMContentLoaded', function () {
  try {
    console.log('glitch-fallback: DOMContentLoaded — running');
    const main = document.getElementById('MainContent') || document.body;
    const h1 = main.querySelector('h1');
    if (!h1) return;

    // Avoid double-wrapping
    if (h1.querySelector('.glitch')) return;

    // Replace the first standalone occurrence of the word "Mistakes" in the H1
    // and inject a simple .glitch span (attributes are fine client-side).
    const html = h1.innerHTML;
    const match = html.match(/\bMistakes\b/);
    if (!match) return;
    const word = match[0];
    const spanHtml = '<span class="glitch" data-text="' + word + '">' + word + '</span>';
    const newHtml = html.replace(/\bMistakes\b/, spanHtml);
    if (newHtml !== html) h1.innerHTML = newHtml;

    // If user prefers reduced motion, don't schedule flickers
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    // Set up low-frequency, irregular flicker bursts
    const glitch = h1.querySelector('.glitch');
    if (!glitch) return;

    function rand(min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; }

    let scheduled = true;
    function scheduleNext() {
      if (!scheduled) return;
      const nextMs = rand(8000, 18000); // 8s - 18s between bursts
      setTimeout(() => {
        triggerBurst();
      }, nextMs);
    }

    function triggerBurst() {
      // number of quick flicks in this burst
      const flicks = rand(1, 2);
      // duration of each flick animation
      const duration = rand(120, 320);
      // set CSS var for duration so CSS animation uses it
      glitch.style.setProperty('--glitch-duration', duration + 'ms');

      // perform flicks sequentially
      let i = 0;
      function doFlick() {
        // add class to trigger animation
        glitch.classList.add('flicker');
        // remove after duration
        setTimeout(() => {
          glitch.classList.remove('flicker');
          i++;
          if (i < flicks) {
            // tiny gap between flicks
            setTimeout(doFlick, rand(160, 420));
          } else {
            // schedule next burst
            scheduleNext();
          }
        }, duration + 20);
      }
      doFlick();
    }

    // start schedule
    scheduleNext();
    // Debug: if ?glitch_test=1 in the URL, trigger an immediate test burst
    try {
      if (new URLSearchParams(window.location.search).has('glitch_test')) {
        console.log('glitch-fallback: debug query present — firing immediate test burst');
        setTimeout(() => triggerBurst(), 100);
      }
    } catch (e) {
      // ignore URL parsing problems in old browsers
    }

    // Optional: pixelate the end of the word for a blocky/pixel effect
    // URL test param: ?pixelate_end=3 (number of final characters to pixelate)
    try {
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const url = new URL(window.location.href);
        const pxCount = url.searchParams.has('pixelate_end') ? parseInt(url.searchParams.get('pixelate_end'), 10) : 0;
        if (pxCount > 0) {
          // find the injected glitch span (or the original if present)
          const target = h1.querySelector('.glitch') || h1.querySelector('span');
          if (target) {
            try { pixelateEndOfText(target, Math.max(1, pxCount)); } catch (e) { console.error('glitch-pixelate error', e); }
          }
        }
      }
    } catch (e) {
      // ignore
    }
  } catch (e) {
    // Fail silently — don't break the page if unexpected structure
    console.error('glitch-fallback error', e);
  }
});

// Pixelate the final `count` characters of an element's text by rasterizing
// them into a small canvas and scaling it up with `image-rendering: pixelated`.
function pixelateEndOfText(el, count, pixelSize = 6) {
  if (!el || !el.textContent) return;
  const text = el.textContent;
  if (text.length <= count) return;

  const prefix = text.slice(0, text.length - count);
  const suffix = text.slice(text.length - count);

  // Create wrapper so we can keep original styles for the prefix
  const wrapper = document.createElement('span');
  wrapper.className = 'glitch-pixel-wrapper';
  const prefixNode = document.createTextNode(prefix);
  const suffixSpan = document.createElement('span');
  suffixSpan.className = 'glitch-pixel-suffix';
  suffixSpan.textContent = suffix;
  wrapper.appendChild(prefixNode);
  wrapper.appendChild(suffixSpan);

  // Replace the element's text with wrapper
  // If el contains HTML (e.g. pseudo-elements), we replace textContent only
  el.textContent = '';
  el.appendChild(wrapper);

  // Render the suffix into a pixelated canvas
  renderPixelatedCanvasForText(suffixSpan, pixelSize);
}

function renderPixelatedCanvasForText(span, pixelSize) {
  const cs = window.getComputedStyle(span);
  const font = cs.font || `${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`;
  const color = cs.color || '#000';
  const text = span.textContent || '';
  if (!text) return;

  // Temporary canvas to measure and draw at normal size
  const tmp = document.createElement('canvas');
  const tctx = tmp.getContext('2d');
  tctx.font = font;
  const metrics = tctx.measureText(text);
  const textWidth = Math.ceil(metrics.width) || 1;
  const fontSize = Math.ceil(parseFloat(cs.fontSize) || 16);
  const textHeight = Math.ceil(fontSize * 1.2);
  tmp.width = textWidth;
  tmp.height = textHeight;
  tctx.font = font;
  tctx.textBaseline = 'top';
  tctx.fillStyle = color;
  // draw text onto tmp canvas
  tctx.fillText(text, 0, 0);

  // Small canvas to hold downscaled image
  const small = document.createElement('canvas');
  small.width = Math.max(1, Math.floor(textWidth / pixelSize));
  small.height = Math.max(1, Math.floor(textHeight / pixelSize));
  const sctx = small.getContext('2d');
  sctx.imageSmoothingEnabled = false;
  // draw tmp into small (downscale)
  sctx.drawImage(tmp, 0, 0, tmp.width, tmp.height, 0, 0, small.width, small.height);

  // Style small canvas so it visually matches original size but uses pixelated rendering
  small.style.width = tmp.width + 'px';
  small.style.height = tmp.height + 'px';
  small.style.imageRendering = 'pixelated';
  small.style.verticalAlign = cs.verticalAlign || 'baseline';
  small.className = 'glitch-pixel-canvas';

  // Replace the suffix span with the pixel canvas
  span.replaceWith(small);
}
